<template>
  <div class="ru-view-toolbar">
    <div class="ru-view-toolbar__actions d-flex justify-end align-center" v-if="shouldShowToolbar">
    <!-- <v-btn-toggle mandatory :value="toggleview" class="align-center">
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="shadow-off"
            small
            :disabled="selectedperiod === 'all'"
            :value="0"
            @click="emitNavigate('listru')"
          >
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
        </template>
        <span>{{ $nova.labelsName('cycle_page', 'ru_entity_label', 'Reporting Unit') }} list</span>
      </v-tooltip>
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="shadow-off"
            small
            :value="1"
            @click="emitNavigate('period')"
          >
            <v-icon>mdi-sitemap</v-icon>
          </v-btn>
        </template>
        <span>Card View</span>
      </v-tooltip>
      <v-tooltip bottom content-class="tooltip-bottom">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="shadow-off"
            small
            :value="2"
            @click="emitNavigate('network')"
          >
            <v-icon>mdi-table</v-icon>
          </v-btn>
        </template>
        <span>Table View</span>
      </v-tooltip>
      <v-tooltip
        bottom
        content-class="tooltip-bottom"
        v-if="selectedperiod && selectedperiod !== 'all'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="shadow-off"
            small
            :value="3"
            @click="emitNavigate('dashboard')"
          >
            <v-icon>mdi-file-table-box-multiple-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ commentaryRegionalKeyLabel }} Dashboard View</span>
      </v-tooltip>
    </v-btn-toggle> -->
    <v-spacer></v-spacer>
    <v-tooltip
      bottom
      content-class="tooltip-bottom"
      v-if="selectedregionalapproval.length > 1 && toggleview === 0 && isregionalapproverinru"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off icon-24"
          color="success"
          @click="emitApproveRegionalRU"
        >
          <img src="/img/icons/ApproveGreenIcon.svg" alt="Approve Green Icon">
        </v-btn>
      </template>
      <span>Approve selected regional cycles</span>
    </v-tooltip>
    <v-tooltip
      left
      content-class="tooltip-left"
      v-if="selectedlocalapproval.length > 1 && toggleview === 0 && islocalapproverinru"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off icon-24"
          color="success"
          @click="emitApproveLocalRU"
        >
          <img src="/img/icons/ApproveGreenIcon.svg" alt="Approve Green Icon">
        </v-btn>
      </template>
      <span>Approve selected local cycles</span>
    </v-tooltip>
    <v-tooltip
      left
      content-class="tooltip-left"
      v-if="selectedlocalapproval.length > 1 && toggleview === 0 && islocalapproverinru"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off icon-24"
          color="success"
          @click="emitSendReminderEmailMulti"
        >
          <img src="/img/icons/EmailGreenIcon.svg" alt="Email Outline Icon" class="icon-24">
        </v-btn>
      </template>
      <span>Send Reminder Mail for selected local cycles</span>
    </v-tooltip>
    <v-tooltip bottom content-class="tooltip-bottom" v-if="reportingUnitsForMailReminder.length > 1">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off icon-24"
          color="success"
          @click="emitShowEmailReminderConfirm"
        >
          <img src="/img/icons/EmailGreenIcon.svg" alt="Email Outline Icon" class="icon-24">
        </v-btn>
      </template>
      <span>{{ 'Send Reminder Mail for Selected Reporting Units' }}</span>
    </v-tooltip>
    <h6 v-if="toggleview === 1 && (selectednetwork === 'all' || selectedperiod === 'all')" class="mt-1">
      {{ 'Last Updated At:' }} {{ lastUpdatedAt }}
    </h6>
    <v-tooltip bottom content-class="tooltip-bottom" v-if="toggleview === 1">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="emitSyncNow"
        >
          <v-icon>mdi-sync</v-icon>
        </v-btn>
      </template>
      <span class="text-capitalize">{{ 'Sync Now' }}</span>
    </v-tooltip>
    <!-- <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="emitDownloadAllRuCycle"
        >
          <v-icon>mdi-table-arrow-down</v-icon>
        </v-btn>
      </template>
      <span>
        {{
          $nova.labelsName(
            'cycle_page',
            'commentary_all_units_cycle_report_tooltip',
            'All Units Cycle Report'
          )
        }}
      </span>
    </v-tooltip>
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="emitDownloadAllRuData"
        >
          <v-icon>mdi-table-arrow-down</v-icon>
        </v-btn>
      </template>
      <span>
        {{
          $nova.labelsName(
            'cycle_page',
            'commentary_all_units_data_report_tooltip',
            'All Units Data Report'
          )
        }}
      </span>
    </v-tooltip>
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="emitRefreshData"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span>{{ $nova.labelsName('cycle_page', 'commentary_refresh_label', 'Refresh') }}</span>
    </v-tooltip> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'RUViewToolbar',
  props: {
    toggleview: { type: Number, default: 0 },
    selectedreportingunit: { type: [String, Number, Object], default: null },
    selectedperiod: { type: [String, Number, Object], default: null },
    selectedregionalapproval: { type: Array, default: () => [] },
    selectedlocalapproval: { type: Array, default: () => [] },
    isregionalapproverinru: { type: Boolean, default: false },
    islocalapproverinru: { type: Boolean, default: false },
    reportingUnitsForMailReminder: { type: Array, default: () => [] },
    selectednetwork: { type: [String, Number, Object], default: 'all' },
    lastUpdatedAt: { type: String, default: '' },
    commentaryRegionalKeyLabel: { type: String, default: '' },
  },
  computed: {
    shouldShowToolbar() {
      return (
        !this.selectedreportingunit ||
        this.selectedreportingunit === 'all' ||
        !this.selectedperiod
      );
    },
  },
  methods: {
    emitNavigate(viewKey) {
      this.$emit('navigate-view', viewKey);
    },
    emitApproveRegionalRU() {
      this.$emit('approve-regional-ru');
    },
    emitApproveLocalRU() {
      this.$emit('approve-local-ru');
    },
    emitSendReminderEmailMulti() {
      this.$emit('send-reminder-email-multi');
    },
    emitShowEmailReminderConfirm() {
      this.$emit('show-email-reminder');
    },
    emitSyncNow() {
      this.$emit('sync-now');
    },
    emitDownloadAllRuCycle() {
      this.$emit('download-all-ru-cycle');
    },
    emitDownloadAllRuData() {
      this.$emit('download-all-ru');
    },
    emitRefreshData() {
      this.$emit('refresh-data');
    },
  },
};
</script>

<style scoped>
.ru-view-toolbar {
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  padding-top:0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* padding: 16px 12px 0 0; */
}

.ru-view-toolbar__actions {
  gap: 4px;
}
</style>
